module.exports = __webpack_public_path__ + "f3d1a9194a16176a1084320922d0005f.svg";